import { VelocityEnv, PublicKey } from '@velocity-exchange/sdk';
import { abbreviateAddress } from '@velocity-exchange/common';
import { AccountData } from 'src/stores/useVelocityAccountsStore';
import {
	LP_SUBACCOUNT_NAME,
	NEW_LP_SUBACCOUNT_NAME,
} from 'src/constants/constants';

export const getDelegateAccountLabel = (account: AccountData): string => {
	if (!account) return '';
	return `${abbreviateAddress(account.authority)} (${account.userId})`;
};

export const getSubAccountStorageKey = (
	authority: PublicKey,
	env: VelocityEnv
) => {
	return authority ? `${authority?.toString()}_subacct_${env}` : '';
};

export const accountNameIsLp = (accountName: string) =>
	[LP_SUBACCOUNT_NAME, NEW_LP_SUBACCOUNT_NAME].includes(accountName);

/**
 * Reads an account's `User` client only while it is still subscribed.
 *
 * Wallet disconnects and RPC reconnects unsubscribe every `User`, and reads on an
 * unsubscribed one throw `NotSubscribedError` instead of returning undefined. Snapshot
 * consumers (`useTickedAllSubAccounts`, `useTickedAccountData`) hold the reference past
 * that point, so `account.client?.x()` is not a safe read — it only guards a missing
 * client, not a dead one.
 */
export const getSubscribedClient = (account: AccountData | undefined) =>
	account?.client?.isSubscribed ? account.client : undefined;
